// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"a99d547f","239":"dac06248","329":"dd008b3c","389":"59ca09a1","453":"f88409ed","455":"7ac8d574","654":"9cfa0ee3","821":"b407c8a5","830":"32d4b5c7","972":"659422c1","977":"e9d662d1"}[chunkId] + ".chunk.js";
};